/* eslint-disable react/react-in-jsx-scope */
import { useTranslation } from 'react-i18next'
import { useLocation, NavLink } from 'react-router-dom'
import { useState } from 'react'
import Text from '../textStyleDefault/texto'
import cruz from '../../../assets/images/inicio/Group.svg'

const CookieWarning = (): any => {
  const { t } = useTranslation()
  const location = useLocation()

  // Leer flag de localStorage para mostrar solo la primera vez
  const [isVisible, setIsVisible] = useState(() => {
    const saved = localStorage.getItem('cookieBannerClosed')
    return saved !== 'true'
  })
  // Cuando cerramos, guardamos flag
  const close = (): void => {
    setIsVisible(false)
    localStorage.setItem('cookieBannerClosed', 'true')
  }
  // Si navegamos a política de cookies, o ya se cerró, no renderizar
  if (location.pathname === '/politica-de-cookies' || !isVisible) {
    return null
  }

  return (
    <div className="fixed bottom-4 left-1/2 translate-x-[-50%] w-[99%] z-[9999] rounded-lg border border-[#CED6E0] bg-white px-3 pt-3 xl:h-[104px]">
      <div className="flex flex-col gap-6 xl:hidden h-96">
        <img src={cruz} alt="Cerrar" onClick={close} className="cursor-pointer self-end" />
        <div className="text-[#043873] h-52 w-72 text-start self-center">
          <Text variant="textoCookies">{t('cookies')}</Text>
        </div>
        <button
          type="button"
          className="bg-white flex text-[#043873] rounded-lg py-4 px-10 h-[60px] outline outline-[1px] outline-[#043873] items-center gap-[10px] self-end"
        >
          <NavLink to="/politica-cookies" className="underline">
            {t('cerrar')}
          </NavLink>
        </button>
      </div>
      <div className="hidden xl:inline-flex xl:max-w-full xl:w-[1439px] xl:justify-evenly xl:items-center text-[#043873]">
        <div className="xl:max-w-[1000px] justify-start flex text-start">
          <Text variant="textoCookies">{t('cookies')}</Text>
        </div>
        <NavLink to="/politica-cookies" className="underline" onClick={close}>
        <button
          type="button"
          className="bg-white inline-flex text-[#043873] rounded-lg py-4 px-10 h-[60px] outline outline-[1px] outline-[#043873] justify-center items-center gap-[10px]"
        >
            {t('cerrar')}
            </button>
          </NavLink>
        <img src={cruz} alt="Cerrar" onClick={close} className="cursor-pointer" />
      </div>
    </div>
  )
}

export default CookieWarning
